module.exports = __webpack_public_path__ + "static/img/分享.cdf2380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/分享.png
// module id = W/H0
// module chunks = 16